export default __webpack_public_path__ + "static/media/Cart_Blue.b5055e56.svg";